import classes from "./index.module.scss";
import Container from "../Container";
import Title from "../Title";
import { useContext, useDeferredValue, useEffect, useState } from "react";
import { FetchContext } from "../../../context/FetchContext";
import { v4 as uuid } from "uuid";
import Card from "./Card";

export default function Team() {
  const {
    store: {
      team,
      team: {
        queries: { team: teamQuery },
        team: { hasMore, loading: teamLoading },
      },
    },
    getItem,
    setPageQuery,
  } = useContext(FetchContext);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(8);

  useEffect(() => {
    getItem({
      propName: "team",
      entity: "team",
      query: teamQuery,
    });
  }, [JSON.stringify(teamQuery)]);

  useEffect(() => {
    setPageQuery("team", "team", page, { per_page: perPage });
    return () => {
      setPageQuery("team", "team", 1);
    };
  }, [page, setPageQuery]);

  const deferredTeam = useDeferredValue(team.team.data);

  return (
    <section>
      <Container>
        <div className={classes.body}>
          <Title center={false}>Meet our team</Title>
          <ul className={classes.list}>
            {deferredTeam.map((item) => {
              return (
                <li className={classes.list__item} key={uuid()}>
                  <Card item={item} />
                </li>
              );
            })}
          </ul>
          {hasMore ? (
            <button
              className={classes.button}
              disabled={teamLoading}
              onClick={() => {
                setPerPage(4);
                setPage((prev) => (prev === 1 ? prev + 2 : prev + 1));
              }}
            >
              {teamLoading ? (
                <span className={classes.button__blue}>Loading...</span>
              ) : (
                <span className={classes.button__grey}>view more</span>
              )}
            </button>
          ) : null}
        </div>
      </Container>
    </section>
  );
}
